(function () {
  'use strict';

  function initVyra(section) {
    if (!section || section.dataset.vyraInitialized === 'true') return;
    section.dataset.vyraInitialized = 'true';

    var variantInput = section.querySelector('[data-vyra-variant-input]');
    var variantRadios = section.querySelectorAll('[data-vyra-variant-radio]');
    var submitButton = section.querySelector('[data-vyra-submit]');
    var submitText = section.querySelector('[data-vyra-submit-text]');
    var stickySubmit = section.querySelector('[data-vyra-sticky-submit]');

    // Keep campaign attribution and country on story -> offer navigation.
    // Do not copy a discount, arbitrary redirect, or theme-preview parameter.
    section.querySelectorAll('[data-vyra-preserve-query]').forEach(function (link) {
      var destination = new URL(link.href, window.location.origin);
      var incoming = new URL(window.location.href).searchParams;
      incoming.forEach(function (value, key) {
        if (/^utm_(source|medium|campaign|content|term|id)$/.test(key) || ['fbclid', 'gclid', 'ttclid'].indexOf(key) !== -1 || (key === 'country' && /^[A-Z]{2}$/.test(value))) {
          destination.searchParams.set(key, value);
        }
      });
      link.href = destination.toString();
    });

    function selectVariant(radio) {
      if (!radio) return;

      var variantId = String(radio.value);
      var available = radio.dataset.vyraAvailable === 'true';
      var reviewLocked = submitButton && submitButton.dataset.vyraReview === 'true';

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.setAttribute('value', variantId);
      }

      section.querySelectorAll('[data-vyra-choice]').forEach(function (choice) {
        var choiceRadio = choice.querySelector('[data-vyra-variant-radio]');
        choice.classList.toggle('is-selected', Boolean(choiceRadio && String(choiceRadio.value) === variantId));
      });

      section.querySelectorAll('[data-vyra-price-variant]').forEach(function (price) {
        price.classList.toggle('is-active', price.dataset.vyraPriceVariant === variantId);
      });

      section.querySelectorAll('[data-vyra-button-price]').forEach(function (price) {
        price.classList.toggle('is-hidden', price.dataset.vyraButtonPrice !== variantId);
      });

      section.querySelectorAll('[data-vyra-sticky-price]').forEach(function (price) {
        price.classList.toggle('is-hidden', price.dataset.vyraStickyPrice !== variantId);
      });

      if (submitButton) {
        submitButton.disabled = Boolean(reviewLocked || !available);
        submitButton.setAttribute('aria-disabled', submitButton.disabled ? 'true' : 'false');
      }

      if (stickySubmit) {
        stickySubmit.disabled = Boolean(reviewLocked || !available);
        stickySubmit.setAttribute('aria-disabled', stickySubmit.disabled ? 'true' : 'false');
        var stickyLabel = stickySubmit.querySelector('span');
        if (stickyLabel && submitButton) stickyLabel.textContent = available ? submitButton.dataset.vyraSubmitLabel : submitButton.dataset.vyraUnavailableLabel;
      }

      if (submitText) {
        submitText.textContent = available
          ? submitButton.dataset.vyraSubmitLabel
          : (submitButton.dataset.vyraUnavailableLabel || 'Indisponible');
      }
    }

    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectVariant(radio);
      });
    });

    selectVariant(section.querySelector('[data-vyra-variant-radio]:checked') || variantRadios[0]);

    var productForm = variantInput ? variantInput.form : null;
    if (productForm) {
      var submitting = false;
      var errorBox = document.createElement('p');
      errorBox.setAttribute('role', 'alert');
      errorBox.hidden = true;
      productForm.appendChild(errorBox);
      productForm.addEventListener('submit', async function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        if (submitting || (submitButton && submitButton.disabled)) return;
        submitting = true;
        errorBox.hidden = true;
        var payload = new FormData(productForm);
        if (submitButton) submitButton.disabled = true;
        if (stickySubmit) stickySubmit.disabled = true;
        try {
          var destination = productForm.querySelector('[name="return_to"]').value;
          var response = await fetch(destination.replace(/\/cart$/, '/cart/add.js'), {
            method: 'POST', headers: { Accept: 'application/json' }, body: payload
          });
          var result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || response.statusText);
          window.location.assign(destination);
        } catch (error) {
          errorBox.textContent = error.message;
          errorBox.hidden = false;
          submitting = false;
          selectVariant(section.querySelector('[data-vyra-variant-radio]:checked'));
        }
      });
      productForm.addEventListener('submit', function () {
        var selected = section.querySelector('[data-vyra-variant-radio]:checked') || variantRadios[0];
        if (selected && variantInput) {
          variantInput.value = String(selected.value);
          variantInput.setAttribute('value', String(selected.value));
        }
      }, true);

      productForm.addEventListener('formdata', function (event) {
        var selected = section.querySelector('[data-vyra-variant-radio]:checked') || variantRadios[0];
        if (selected) event.formData.set('id', String(selected.value));
      });
    }

    var quantityInput = section.querySelector('[data-vyra-quantity-input]');
    var quantityValue = section.querySelector('[data-vyra-quantity-value]');
    var quantityMinus = section.querySelector('[data-vyra-quantity-minus]');
    var quantityPlus = section.querySelector('[data-vyra-quantity-plus]');

    function setQuantity(nextValue) {
      var value = Math.max(1, Math.min(5, Number(nextValue) || 1));
      if (quantityInput) quantityInput.value = String(value);
      if (quantityValue) quantityValue.textContent = String(value);
      if (quantityMinus) quantityMinus.disabled = value === 1;
      if (quantityPlus) quantityPlus.disabled = value === 5;
      section.querySelectorAll('[data-vyra-unit-price]').forEach(function (price) {
        price.textContent = new Intl.NumberFormat(section.dataset.locale || 'fr', { style: 'currency', currency: section.dataset.currency || 'EUR' }).format(Number(price.dataset.vyraUnitPrice) * value / 100);
      });
    }

    if (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        setQuantity(Number(quantityInput.value) - 1);
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        setQuantity(Number(quantityInput.value) + 1);
      });
    }
    if (quantityInput) setQuantity(quantityInput.value);

    var range = section.querySelector('[data-vyra-range]');
    var compare = range ? range.closest('.vyra-compare') : null;

    if (range && compare) {
      var updateComparison = function () {
        var value = Number(range.value);
        compare.style.setProperty('--vyra-position', value + '%');
        compare.classList.add('is-touched');
        range.setAttribute('aria-valuetext', value + ' %');
      };

      range.addEventListener('input', updateComparison);
      range.addEventListener('change', updateComparison);
    }

    var reveals = section.querySelectorAll('[data-vyra-reveal]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (node) {
        node.classList.add('vyra-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vyra-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    reveals.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initAllVyra() {
    document.querySelectorAll('[data-vyra-section]').forEach(initVyra);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVyra, { once: true });
  } else {
    initAllVyra();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-vyra-section]')
      ? event.target
      : event.target.querySelector('[data-vyra-section]');
    initVyra(section);
  });
})();
